import React from 'react';
import { useTheme } from '../../ThemeContext';
import { ModalShell, Button } from '../ui';


export default function ChangeAvatarModal({ 
  show, 
  onClose,
  avatarFile,
  setAvatarFile
}) {
  const { t, isDark } = useTheme();
  if (!show) return null;

  return (
    <ModalShell onClose={onClose} maxWidth="400px" panelStyle={{ backgroundColor: t.modalBg, borderRadius: '16px' }}>
        <h2 style={{ 
          fontFamily: 'Crimson Pro, serif', 
          fontSize: '28px', 
          marginBottom: '8px',
          color: t.text
        }}>
          Change Avatar
        </h2>
        <p style={{ 
          color: t.textSecondary, 
          marginBottom: '24px',
          fontSize: '14px',
          fontFamily: 'Poppins, sans-serif'
        }}>
          Upload a custom avatar image
        </p>

        <div style={{ marginBottom: '24px' }}>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setAvatarFile(e.target.files[0])}
            style={{
              width: '100%',
              padding: '12px',
              border: `1px solid ${t.borderStrong}`,
              borderRadius: '8px',
              fontSize: '14px',
              fontFamily: 'Poppins, sans-serif',
              backgroundColor: t.surface
            }}
          />
          <p style={{ fontSize: '12px', color: t.textSecondary, marginTop: '8px' }}>
            Feature coming soon - file upload functionality
          </p>
        </div>

        <Button onClick={onClose} fullWidth>
          Close
        </Button>
    </ModalShell>
  );
}
